import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faQuestion, faX } from "@fortawesome/free-solid-svg-icons";
import { VerificationType } from "@/common/constants/verification.status.constants";

export const getCurrentStatusIcons = (status) => {
  switch (status) {
    case VerificationType.CORRECT:
      return <FontAwesomeIcon icon={faCheck} style={{ color: "green" }} />;
    case VerificationType.QUESTION:
      return <FontAwesomeIcon icon={faQuestion} style={{ color: "orange" }} />;
    case VerificationType.WRONG:
      return <FontAwesomeIcon icon={faX} style={{ color: "red" }} />;
    default:
      return;
  }
};
